import { useRef, useEffect } from 'react'
import { AppIcon  } from '@/shared/ui/icons'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { confirm } from '@/shared/ui/dialog'

import { useNavigation } from '@/shared/hooks/useNavigation'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { Avatar, useAvatarContext } from '@/shared/ui/Avatar'
import { GuideTour } from '@/shared/ui/GuideTour'
import { Link } from '@/shared/ui/Link'

import { getTourSteps } from './getTourSteps'
import { useAppMenu } from '@/shared/ui/Layout'
import { ACCOUNT_PATHS } from '@/features/user/profile'

export const DigitalProductMyAvatar = () => {
  const { navigateTo } = useNavigation()

  const { open: openAppMenu } = useAppMenu()

  const { userProgress } = useUserProgress()

  const { noAvatar, hasUnsavedChanges, avatar, changeAvatar, saveAvatar } =
    useAvatarContext()

  const transformComponentRef = useRef(null)

  const handleChange = config => changeAvatar(config)
  const handleSave = async config => {
    // `noAvatar` precisa ser lido antes do save: salvar o primeiro avatar o
    // derruba, e o ramo de onboarding do `saveAvatar` (que leva a `/?tour=1`)
    // deixaria de ser distinguível depois.
    const wasOnboarding = noAvatar

    await saveAvatar(config)

    // O primeiro avatar emenda no tour de onboarding, e a navegação para ele
    // já acontece dentro do `saveAvatar`. Sequestrar esse destino aqui tiraria
    // o participante novo do fluxo de entrada. Quem está reeditando volta para
    // a seção de perfil, de onde veio.
    if (!wasOnboarding) navigateTo(ACCOUNT_PATHS.profile)
  }
  const handleCancel = () => {
    if (hasUnsavedChanges) {
      void confirm({
        title: 'Tem certeza que deseja descartar as alterações?',
        description:
          'Seu avatar possui alterações não salvas, deseja sair mesmo assim?',
        variant: 'warning',
        confirmLabel: 'Sim, descartar alterações',
        cancelLabel: 'Cancelar',
        confirmVariant: 'destructive'
      }).then(isConfirmed => {
        if (isConfirmed) navigateTo(ACCOUNT_PATHS.profile)
      })
    } else navigateTo(ACCOUNT_PATHS.profile)
  }
  // const toggleZoom = () => {
  //   if (transformComponentRef.current) {
  //     if (transformComponentRef.current.instance.transformState.scale > 1)
  //       transformComponentRef.current.resetTransform()
  //     else {
  //       const wrapper = document.getElementById('avatar-mobile-preview')
  //       transformComponentRef.current.setTransform(
  //         -wrapper?.clientWidth,
  //         -wrapper?.clientHeight / 1.5,
  //         3
  //       )
  //     }
  //   }
  // }

  useEffect(() => {
    const body = document?.body

    if (isMobile) {
      body.style.setProperty('overflow', 'hidden')
    }

    return () => {
      if (isMobile) {
        body.style.removeProperty('overflow')
      }
    }
  }, [isMobile])

  if (!avatar || _.isEmpty(avatar)) return <></>
  return (
    <div className="fixed lg:relative top-0 left-0 w-full h-full lg:h-auto flex flex-col items-center justify-center py-4 px-3 lg:p-0">
      <div
        id="avatar-mobile-preview"
        className="w-full md:h-[400px] relative mb-4 bg-white rounded-md overflow-hidden lg:hidden flex items-center justify-center"
      >
        {!noAvatar && (
          <button
            type="button"
            onClick={() => openAppMenu({ source: 'avatar' })}
            className="absolute top-0 left-0 m-3 flex items-center justify-center w-8 h-8 bg-white rounded-lg shadow-sm text-brand z-[1]"
          >
            <AppIcon  name="bars" className="text-brand text-2xl" />
          </button>
        )}
        <TransformWrapper ref={transformComponentRef}>
          <TransformComponent
            wrapperClass="h-full w-full"
            contentClass="w-full h-full"
          >
            <Avatar config={avatar} showFullBody={true} />
          </TransformComponent>
        </TransformWrapper>
        {!noAvatar && (
          <Link
            href="/"
            className="absolute top-0 right-0 m-3 flex items-center justify-center w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-lg z-[1]"
          >
            <AppIcon  name="times" className="text-gray-600 text-3xl" />
          </Link>
        )}
      </div>
      <Avatar.Editor
        initialConfig={avatar}
        onChange={handleChange}
        onSave={handleSave}
        showCancelButton={!noAvatar}
        onCancel={handleCancel}
      />
      {avatar?._generatedBySystem && (
        <GuideTour steps={getTourSteps(userProgress)} disableScrolling />
      )}
    </div>
  )
}
